import React, { useState } from 'react';
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';

const AssignInstituteC = () => {
  // Data for accordions
  const countries = [
    {
      name: "New Zealand",
      institutes: ["Sanjat Management School"]
    },
    {
      name: "Lativa",
      institutes: ["Riga College of Business & Technology"]
    },
    {
      name: "New Zealand",
      institutes: Array(12).fill("Lona College")
    },
    {
      name: "United Kingdom",
      institutes: Array(12).fill("Lona College")
    },
    {
      name: "United States",
      institutes: Array(12).fill("Lona College")
    }
  ];

  return (
    <div className="container py-4">
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 px-3 py-2 mb-2 text-center bg-dark text-white">
          Assign Institute
        </div>
      </div>
      
      <div className="card mb-4 shadow-sm">
        <div className='fw-bold fs-4 mx-3'>
          List Of Unassigned Institute
        </div>
        
        <div className="card-body row">
          {/* Single accordion container with one ID */}
          <div className="accordion" id="institutesAccordion">
            {countries.map((country, countryIndex) => (
              <div className="col-md-12 col-12 mb-3" key={countryIndex}>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button 
                      className="accordion-button bg-white" 
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target={`#collapse-${countryIndex}`}
                      aria-expanded={countryIndex === 0 ? "true" : "false"}
                      aria-controls={`collapse-${countryIndex}`}
                    >
                      {country.name}
                    </button>
                  </h2>
                  
                  <div 
                    id={`collapse-${countryIndex}`} 
                    className={`accordion-collapse collapse ${countryIndex === 0 ? "show" : ""}`}
                    data-bs-parent="#institutesAccordion"
                  >
                    <div className="accordion-body">
                      <div className='row'>
                        {country.institutes.map((institute, instituteIndex) => (
                          <div 
                            key={instituteIndex} 
                            className={country.institutes.length > 6 ? 'col-md-6' : 'col-md-12'}
                          >
                            <div className='mt-2'>
                              <input 
                                type="checkbox" 
                                id={`institute-${countryIndex}-${instituteIndex}`} 
                                className="" 
                              /> 
                              <label className='mx-2' htmlFor={`institute-${countryIndex}-${instituteIndex}`}>
                                {institute}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="d-flex gap-2 pt-3 pb-3">
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>

          <div className="mt-3">
            <Link to={'/super-admin/counsellor'} type="button" className="btn bg-light buttonadd">
              <IoArrowUndoSharp size={20} /> Back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignInstituteC;